export enum RoutingStateKeysEnum {
	shouldCopyChildRecords = 'shouldCopyChildRecords'
}
